import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="channel-click-up"
export default class extends Controller {
  static targets = [
    "workspaceId",
    "teamspaceId",
    "folderId",
    "listId",
    "initialStatusId",
    "resolveStatusId",
    "reopenStatusId",
    "workspaceName",
    "teamspaceName",
    "folderName",
    "listName",
    "tags",
    "titleFormat",
    "descriptionFormat",
  ];

  static values = {
    projectId: Number,
    channelId: Number,
  }

  initialize() {
    this.constructor.targets.forEach((targetName) => this[`${targetName}Changed`] ||= function() {});
  }

  connect() {
    this.workspaceSelect = $(this.workspaceIdTarget);
    this.teamspaceSelect = $(this.teamspaceIdTarget);
    this.folderSelect = $(this.folderIdTarget);
    this.listSelect = $(this.listIdTarget);
    this.initialStatusSelect = $(this.initialStatusIdTarget);
    this.resolveStatusSelect = $(this.resolveStatusIdTarget);
    this.reopenStatusSelect = $(this.reopenStatusIdTarget);

    [this.workspaceSelect, this.teamspaceSelect, this.folderSelect, this.listSelect, this.initialStatusSelect, this.resolveStatusSelect, this.reopenStatusSelect].forEach((select) => {
      select.attr('disabled', true);
    });

    this.loadWorkspaces();
    this.loadTeamspaces(this.workspaceSelect.attr('value'));
    this.loadFolders(this.teamspaceSelect.attr('value'));
    this.loadLists(this.folderSelect.attr('value'), this.teamspaceSelect.attr('value'));
    this.loadStatuses(this.listSelect.attr('value'));
  }

  loadWorkspaces() {
    this.workspaceSelect.attr('disabled', true).empty().append($("<option>Loading workspaces</option>"));
    this.loadData('/workspaces', this.workspaceSelect);
  }

  loadTeamspaces(teamId) {
    if (teamId) {
      this.teamspaceSelect.attr('disabled', true).empty().append($("<option>Loading teamspaces</option>"));
      this.loadData(`/teamspaces?team_id=${teamId}`, this.teamspaceSelect);
    }
  }

  loadFolders(spaceId) {
    if (spaceId) {
      this.folderSelect.attr('disabled', true).empty().append($("<option value=\"\">Loading folders</option>"));
      this.loadData(`/folders?space_id=${spaceId}`, this.folderSelect);
    }
  }

  loadLists(folderId, spaceId) {
    if (folderId || spaceId) {
      this.listSelect.attr('disabled', true).empty().append($("<option>Loading lists</option>"));
      folderId = folderId ? folderId : '';
      this.loadData(`/lists?folder_id=${folderId}&space_id=${spaceId}`, this.listSelect);
    }

    // Because a folder is not required, this makes sure the folder name is cleared when a folder is no longer selected.
    if (!folderId) {
      this.folderNameTarget.value = '';
    }
  }

  loadStatuses(listId) {
    if (listId) {
      this.initialStatusSelect.attr('disabled', true).empty().append($("<option>Loading statuses</option>"));
      this.resolveStatusSelect.attr('disabled', true).empty().append($("<option>Loading statuses</option>"));
      this.reopenStatusSelect.attr('disabled', true).empty().append($("<option>Loading statuses</option>"));
      this.loadData(`/statuses?list_id=${listId}`, [this.initialStatusSelect, this.resolveStatusSelect, this.reopenStatusSelect]);
    }
  }

  workspaceIdChanged() {
    this.teamspaceSelect.attr('disabled', true).empty();
    this.folderSelect.attr('disabled', true).empty();
    this.listSelect.attr('disabled', true).empty();
    this.initialStatusSelect.attr('disabled', true).empty();
    this.resolveStatusSelect.attr('disabled', true).empty();
    this.reopenStatusSelect.attr('disabled', true).empty();
    this.workspaceNameTarget.value = this.workspaceSelect.find('option:selected').text();
    this.loadTeamspaces(this.workspaceSelect.val());
  }

  teamspaceIdChanged() {
    this.folderSelect.attr('disabled', true).empty();
    this.listSelect.attr('disabled', true).empty();
    this.initialStatusSelect.attr('disabled', true).empty();
    this.resolveStatusSelect.attr('disabled', true).empty();
    this.reopenStatusSelect.attr('disabled', true).empty();
    this.teamspaceNameTarget.value = this.teamspaceSelect.find('option:selected').text();
    this.loadFolders(this.teamspaceSelect.val());
    this.loadLists(this.folderSelect.val(), this.teamspaceSelect.val());
  }

  folderIdChanged() {
    this.listSelect.attr('disabled', true).empty();
    this.initialStatusSelect.attr('disabled', true).empty();
    this.resolveStatusSelect.attr('disabled', true).empty();
    this.reopenStatusSelect.attr('disabled', true).empty();
    this.folderNameTarget.value = this.folderSelect.find('option:selected').text();
    this.loadLists(this.folderSelect.val(), this.teamspaceSelect.val());
  }

  listIdChanged() {
    this.initialStatusSelect.attr('disabled', true).empty();
    this.resolveStatusSelect.attr('disabled', true).empty();
    this.reopenStatusSelect.attr('disabled', true).empty();
    this.listNameTarget.value = this.listSelect.find('option:selected').text();
    this.loadStatuses(this.listSelect.val());
  }

  channelUrl(path) {
    return `/projects/${this.projectIdValue}/channels/${this.channelIdValue}/click_up${path}`;
  }

  loadData(path, selectElements) {
    $.ajax(this.channelUrl(path), {
      type: 'get',
      dataType: 'json',
      success: (...args) => [].concat(selectElements).forEach((selectElement) => this.populateSelect(selectElement, ...args)),
      error: (...args) => this.reportError(...args),
    });
  }

  populateSelect(selectElement, items) {
    const selected = selectElement.attr('value');
    selectElement.empty();
    selectElement.append($('<option>'));
    items.forEach(item => {
      selectElement.append(
        $('<option>', {
          value: item.id,
          text: item.name,
          selected: item.id === selected,
        }),
      );
      selectElement.removeAttr('disabled');
    });
  }

  reportError(xhr, status, error) {
    if (error.match(/forbidden/i)) {
      alert('ClickUp access denied: Invalid API Key');
    }
  }
}
